import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import AriaTooltipComponent from './common/tooltipComponent/AriaTooltipComponent';
import { disableTopicTree } from '../../lib/globalHelper';

const recommend = i18n.message('smarthelp/contactOption.recommend');
// const chat = i18n.message('smarthelp/contactOption.chat');
const tooltip = i18n.message('smarthelp/contactOption.recommended.tooltip');

class ContactOption extends Component {
  static getTopicTreeDisabledStyle() {
    return disableTopicTree() ? { float: 'none' } : {};
  }

  renderRecommended() {
    if (!this.props.recommended) {
      return null;
    }
    return (
      <div className="recommended">
        <AriaTooltipComponent
          message={tooltip}
          direction="bottom"
        >
          <button className="icon-recommended">{recommend}</button>
        </AriaTooltipComponent>
      </div>
    );
  }

  renderMessage() {
    return this.props.message ? (
      <div className={this.props.supportMessageCSS}>
        {Page.getHTMLElement({ message: this.props.message, useHTML: true })}
      </div>
    ) : null;
  }

  renderContactText() {
    let Tag = 'button';

    const attrs = {
      className: this.props.contactLinkCSS,
    };

    if (this.props.link) {
      Tag = 'a';
      attrs.onClick = (e) => { e.preventDefault(); return this.props.clickAction(); };
      attrs.href = this.props.link;
      attrs.target = this.props.sameTab ? '' : '_blank';
    } else {
      attrs.onClick = () => this.props.clickAction();
    }

    if (this.props.tabIndex) {
      attrs.tabIndex = this.props.tabIndex;
    }

    return <Tag {...attrs}>{this.props.text}</Tag>;
  }

  render() {
    const attrs = {
      className: 'contact-panel',
      id: `contact-${this.props.id}`,
      style: ContactOption.getTopicTreeDisabledStyle(),
    };

    return (
      <div {...attrs}>
        <div className={this.props.iconClass} aria-hidden="true" />
        <div className="channel-content">
          {this.renderContactText()}
          {this.renderMessage()}
          {this.renderRecommended()}
        </div>
      </div>
    );
  }
}

ContactOption.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  contactLinkCSS: PropTypes.string.isRequired,
  clickAction: PropTypes.func.isRequired,
  iconClass: PropTypes.string.isRequired,
  supportMessageCSS: PropTypes.string.isRequired,
  recommended: PropTypes.bool,
  // toolTip: PropTypes.bool,
  link: PropTypes.string,
  sameTab: PropTypes.bool,
  tabIndex: PropTypes.number,
};

ContactOption.defaultProps = {
  recommended: false,
  // toolTip: false,
  link: undefined,
  sameTab: false,
  datapaClick: '',
  tabIndex: 0,
};

export default ContactOption;
